/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Accounting service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: dev@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CreditPaymentLimitedResponse } from '../model';
// @ts-ignore
import { GetFurthestUnPaidStatusReportResponse } from '../model';
// @ts-ignore
import { PayingStatusReportSummaryResponse } from '../model';
/**
 * StatusReportSummaryApiUserReportFurthestUnPaidStatusReportGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function StatusReportSummaryApiUserReportFurthestUnPaidStatusReportGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/UserReport/furthestUnPaidStatusReport`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * StatusReportSummaryApiUserReportIsCreditPaymentLimitedGet - axios parameter creator
 * 
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function StatusReportSummaryApiUserReportIsCreditPaymentLimitedGetAxiosParamCreator (userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/UserReport/isCreditPaymentLimited`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * StatusReportSummaryApiUserReportPayingStatusReportSummaryGet - axios parameter creator
 * 
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function StatusReportSummaryApiUserReportPayingStatusReportSummaryGetAxiosParamCreator (userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/UserReport/payingStatusReportSummary`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['UserId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for userReportIsCreditPaymentLimitedGet operation in StatusReportSummaryApi.
 * @export
 * @interface StatusReportSummaryApiUserReportIsCreditPaymentLimitedGetRequest
 */
export interface StatusReportSummaryApiUserReportIsCreditPaymentLimitedGetRequest {
    /**
     * 
     * @type {number}
     * @memberof StatusReportSummaryApiUserReportIsCreditPaymentLimitedGet
     */
    readonly userId?: number
}

/**
 * Request parameters for userReportPayingStatusReportSummaryGet operation in StatusReportSummaryApi.
 * @export
 * @interface StatusReportSummaryApiUserReportPayingStatusReportSummaryGetRequest
 */
export interface StatusReportSummaryApiUserReportPayingStatusReportSummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof StatusReportSummaryApiUserReportPayingStatusReportSummaryGet
     */
    readonly userId?: number
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function StatusReportSummaryApiUserReportFurthestUnPaidStatusReportGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await StatusReportSummaryApiUserReportFurthestUnPaidStatusReportGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<GetFurthestUnPaidStatusReportResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {StatusReportSummaryApiUserReportIsCreditPaymentLimitedGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function StatusReportSummaryApiUserReportIsCreditPaymentLimitedGet(requestParameters: StatusReportSummaryApiUserReportIsCreditPaymentLimitedGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await StatusReportSummaryApiUserReportIsCreditPaymentLimitedGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<CreditPaymentLimitedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {StatusReportSummaryApiUserReportPayingStatusReportSummaryGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function StatusReportSummaryApiUserReportPayingStatusReportSummaryGet(requestParameters: StatusReportSummaryApiUserReportPayingStatusReportSummaryGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await StatusReportSummaryApiUserReportPayingStatusReportSummaryGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<PayingStatusReportSummaryResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
